(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/root/assets/javascripts/root.js') >= 0) return;  svs.modules.push('/components/casino-react/root/assets/javascripts/root.js');
"use strict";


const {
  baseUrl
} = svs.core.data;
const {
  Route,
  Switch,
  BrowserRouter
} = ReactRouterDOM;
const {
  Provider
} = ReactRedux;
const {
  store
} = svs.components.casino_react.casinoStore;
const PageLobby = svs.components.casino_react.pageLobby.PageLobby;
const PageCategoryGames = svs.components.casino_react.pageCategoryGames.PageCategoryGames;
const PageProviderGames = svs.components.casino_react.pageProviderGames.PageProviderGames;
const {
  CasinoSearchForm
} = svs.components.casino_react.casinoSearchForm;
const {
  DebugTools
} = svs.components.casino_react.debug_tools;
const Root = () => React.createElement("div", {
  className: "casino-content"
}, React.createElement(BrowserRouter, {
  basename: baseUrl
}, React.createElement(Provider, {
  store: store
}, React.createElement(Switch, null, React.createElement(Route, {
  component: DebugTools,
  path: "*"
})), React.createElement(Switch, null, React.createElement(Route, {
  component: CasinoSearchForm,
  exact: true,
  path: ['/']
})), React.createElement(Switch, null, React.createElement(Route, {
  component: PageLobby,
  exact: true,
  path: "/"
}), React.createElement(Route, {
  component: PageProviderGames,
  exact: true,
  path: "/leverantorer/:providerName([a-zA-Z0-9-]+)"
}), React.createElement(Route, {
  component: PageCategoryGames,
  path: "/:categoryType(live)?/kategori/:categoryName([a-zA-Z0-9-]+)"
})))));
setGlobal('svs.components.casino_react.root.Root', Root);

 })(window);